import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { RazorPayLogo } from '../svg-icons';
import { CUSTOMER_CARE_ROLES } from '@constants/roles';

const Logo: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies(['role']);
  const role = cookies.role ?? '';

  const isLoginPage = location.pathname === '/login';
  const isEligibilityAttemptsPage =
    location.pathname === '/eligibility-attempts';
  const isCustomerCareRole = CUSTOMER_CARE_ROLES.includes(role);

  // Hide back button on login page or on eligibility attempts page for customer care roles
  const showBackButton =
    !isLoginPage && !(isEligibilityAttemptsPage && isCustomerCareRole);

  return (
    <div className="relative flex w-full items-center justify-center">
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          className="absolute left-4 flex items-center gap-1 text-gray-600 hover:text-blue-600"
        >
          ← <span className="text-sm">Back</span>
        </button>
      )}

      {/* Centered Logo */}
      <img alt="Logo" src="/logo.png" className="h-[58px] w-[89px]" />

      {/* Razorpay at right */}
      <div className="absolute right-4 flex items-center gap-1">
        <span className="text-sm text-gray-600">Powered by</span>
        <RazorPayLogo />
      </div>
    </div>
  );
};

export default Logo;
